import {useQuickViewVariant} from './useQuickViewVariant';

export function useIsQuickView() {
  return useQuickViewVariant() !== 'adp';
}
